import React from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import electricImg from '../../assets/icons/electric.png';
import {eligibilityOutcomes, formatDate, hasOverdueService } from "../../utils/formatting";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getEICR5YServiceCompliance } from "../APIErrorComponent/APIConstantName";
import useBackToTop from "../BackToTop/useBackToTop";

interface EICRCardProps extends RouteComponentProps<any> {
  EICRPropsData: any;
}
const EICRCard: React.FC<EICRCardProps> = ({EICRPropsData}) => {
    const { t } = useTranslation();
    const {width} = useBackToTop();
    return (
    <div className=" relative border pb-16 border-grey bg-grey rounded-lg cust-card">
        <div className="px-4 py-2 border-b border-grey  bg-teal rounded-t-lg">
          <div className="flex flex-row d-flex bd-highlight items-center">
            <img src={electricImg} className=" text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="" />
            <div className={width<820?"":"flex flex-row justify-between items-center "}>
            <h2 className="my-0 text-white bd-highlight">{t("EICR")}
            </h2>
             {hasOverdueService(EICRPropsData?.[0]?.nextServiceDueDate)?<h2 className="my-0 text-white bd-highlight ms-auto">Overdue</h2>:""}
           </div></div>
           </div>   
           {/* Binding data here */}
         <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{t("Due_Date")}</b></div>
          <div className="cardEmail">{formatDate(EICRPropsData?.[0]?.nextServiceDueDate || "-")}</div>
        </div>
        <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{t("Contractor_CP114")}</b></div>
          <div className="cardEmail">{EICRPropsData?.[0]?.contractor?.name || "-"}</div>
        </div>
        <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{t("Contractor_Contact")}</b></div>
          <div className="cardEmail">{EICRPropsData?.[0]?.contractor?.phoneNumber || "-"}</div>
        </div>
        <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{t("Last_Visit")}</b></div>
          <div className="cardEmail">{formatDate(EICRPropsData?.[0]?.lastServiceDueDate|| "-")}</div>
        </div>
        <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{t("Visit_Outcome")}</b></div>
          <div className="cardEmail">{eligibilityOutcomes(EICRPropsData?.[0]) || "-"}</div>
        </div>
        <div className="px-4 topStyle">
          <div className="pr-4 mt-2"><b>{("Date Decommissioned")}</b></div>
          <div className="cardEmail">{formatDate(EICRPropsData?.[0]?.applianceEndDate || "-")}</div>
        </div>
               <ErrorComponent input={[getEICR5YServiceCompliance]} />
    </div> 
    )
};
export default EICRCard;